<template>
  <main-large-dialog
    class="profile"
    :is-visible.sync="computedIsVisible"
    :title="title"
    agree-text="dialog.exportProfile"
    disagree-text="dialog.close"
    max-height="90vh"
    :body-height="bodyHeight"
    min-body-height="300px"
    dialog-width="85vw"
    @agree="exportProfile"
  >
    <template #body>
      <v-col cols="12" v-if="isFetched">
        <v-row no-gutters class="overflow">
          <v-col>
            <img class="mb-3" :src="computedImage" />
          </v-col>
        </v-row>
        <v-row no-gutters class="justify-center slider">
          <v-col cols="12">
            <modeling-results-slider
              ref="sewer-profile-slider"
              v-model="index"
              :timesteps="timesteps"
              :has-play-button="true"
              class="border--top py-2"
            >
            </modeling-results-slider>
          </v-col>
        </v-row>
      </v-col>
      <v-row no-gutters justify="center" v-else>
        <main-loader />
      </v-row>
    </template>
  </main-large-dialog>
</template>

<script>
import { call } from 'vuex-pathify';
import { debounce } from 'lodash';

import MainLoader from '@/components/MainLoader';
import ModelingResultsSlider from '@/components/ModelingResultsSlider';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'SewerProfileDialog',
  components: {
    MainLargeDialog,
    MainLoader,
    ModelingResultsSlider,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    pipes: {
      type: Array,
      required: true,
    },
    scenarioId: {
      type: [String, Number],
      required: true,
    },
    timesteps: {
      type: Array,
      required: true,
    },
    parentImage: {
      type: String,
      required: true,
    },
    imageName: {
      type: String,
      required: true,
    },
  },
  data: vm => ({
    title: vm.$i18n.t('dialog.title.netProfile'),
    image: undefined,
    index: 0,
    isFetched: false,
  }),
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    bodyHeight() {
      return this.isLoading ? '500px' : undefined;
    },
    computedName() {
      return this.isFetched > 0 ? this.name : this.imageName;
    },
    computedImage() {
      return this.isFetched > 0 ? this.image : this.parentImage;
    },
  },
  watch: {
    isVisible(nV) {
      if (nV) {
        this.isFetched = false;
        this.onOpened();
      } else {
        this.onClosed();
      }
    },
    index() {
      this.debouncedOnOpened();
    },
  },
  methods: {
    getProfile: call('modeling/getProfile'),
    async onOpened() {
      try {
        const { pipes, scenarioId, index } = this;
        const r = await this.getProfile({ pipes, scenarioId, index });
        this.name = this.$_extractFilename(r.headers);
        this.image = this.$_createImageFromArrayBuffer(r.data, r.headers);
        this.isFetched = true;
      } catch (error) {
        console.log('  error', error);
      }
    },
    onClosed() {
      this.$refs['sewer-profile-slider'].pauseAnimation();
      this.index = 0;
      this.isLoading = true;
    },
    exportProfile() {
      this.$_saveFile(this.computedImage, this.computedName);
    },
  },
  mounted() {
    this.debouncedOnOpened = debounce(this.onOpened, 300);
    this.onOpened();
  },
};
</script>

<style lang="scss" scoped>
.overflow {
  max-height: 45vh;
  overflow: auto;
}
.slider {
  background-color: white;
  position: sticky;
  bottom: 0;
  .border--top {
    @include border(top);
  }
}
</style>

<style lang="scss">
.v-card__text {
  overflow-y: hidden !important;
}
</style>
